'use strict';
/**
 * Dependencies
 */

var _classCallCheck = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var toCamelCase = require('../helpers/to-camel-case');

var toSnakeCase = require('../helpers/to-snake-case');

var deepClone = require('../helpers/deep-clone');

var fs = require('fs');

var path = require('path');
/**
 * Attachment class
 */


var Attachment = /*#__PURE__*/function () {
  /**
   * Constructor
   */
  function Attachment(data) {
    _classCallCheck(this, Attachment);

    //Create from data
    if (data) {
      this.fromData(data);
    }
  }
  /**
   * From data
   */


  _createClass(Attachment, [{
    key: "fromData",
    value: function fromData(data) {
      //Expecting object
      if (typeof data !== 'object') {
        throw new Error('Expecting object for Mail data');
      } //Convert to camel case to make it workable, making a copy to prevent
      //changes to the original objects


      data = deepClone(data);
      data = toCamelCase(data); //Extract properties from data

      var _data = data,
          content = _data.content,
          filename = _data.filename,
          type = _data.type,
          disposition = _data.disposition,
          contentId = _data.contentId,
          filePath = _data.filePath;

      if (typeof content !== 'undefined' && typeof filePath !== 'undefined') {
        throw new Error("The props 'content' and 'filePath' cannot be used together.");
      } //Set data


      this.setFilename(filename);
      this.setType(type);
      this.setDisposition(disposition);
      this.setContentId(contentId);
      this.setContent(filePath ? this.readFile(filePath) : content);
    }
    /**
     * Read a file and return its content as base64
     */

  }, {
    key: "readFile",
    value: function readFile(filePath) {
      return fs.readFileSync(path.resolve(filePath));
    }
    /**
     * Set content
     */

  }, {
    key: "setContent",
    value: function setContent(content) {
      //Duck type check toString on content if it's a Buffer as that's the method that will be called.
      if (typeof content === 'string') {
        this.content = content;
        return;
      } else if (content instanceof Buffer && content.toString !== undefined) {
        this.content = content.toString();

        if (this.disposition === 'attachment') {
          this.content = content.toString('base64');
        }

        return;
      }

      throw new Error('`content` expected to be either Buffer or string');
    }
    /**
     * Set content
     */

  }, {
    key: "setFileContent",
    value: function setFileContent(content) {
      if (content instanceof Buffer && content.toString !== undefined) {
        this.content = content.toString('base64');
        return;
      }

      throw new Error('`content` expected to be Buffer');
    }
    /**
     * Set filename
     */

  }, {
    key: "setFilename",
    value: function setFilename(filename) {
      if (typeof filename === 'undefined') {
        return;
      }

      if (filename && typeof filename !== 'string') {
        throw new Error('String expected for `filename`');
      }

      this.filename = filename;
    }
    /**
     * Set type
     */

  }, {
    key: "setType",
    value: function setType(type) {
      if (typeof type === 'undefined') {
        return;
      }

      if (typeof type !== 'string') {
        throw new Error('String expected for `type`');
      }

      this.type = type;
    }
    /**
     * Set disposition
     */

  }, {
    key: "setDisposition",
    value: function setDisposition(disposition) {
      if (typeof disposition === 'undefined') {
        return;
      }

      if (typeof disposition !== 'string') {
        throw new Error('String expected for `disposition`');
      }

      this.disposition = disposition;
    }
    /**
     * Set content ID
     */

  }, {
    key: "setContentId",
    value: function setContentId(contentId) {
      if (typeof contentId === 'undefined') {
        return;
      }

      if (typeof contentId !== 'string') {
        throw new Error('String expected for `contentId`');
      }

      this.contentId = contentId;
    }
    /**
     * To JSON
     */

  }, {
    key: "toJSON",
    value: function toJSON() {
      //Extract properties from self
      var content = this.content,
          filename = this.filename,
          type = this.type,
          disposition = this.disposition,
          contentId = this.contentId; //Initialize with mandatory properties

      var json = {
        content: content,
        filename: filename
      }; //Add whatever else we have

      if (typeof type !== 'undefined') {
        json.type = type;
      }

      if (typeof disposition !== 'undefined') {
        json.disposition = disposition;
      }

      if (typeof contentId !== 'undefined') {
        json.contentId = contentId;
      } //Return


      return toSnakeCase(json);
    }
  }]);

  return Attachment;
}(); //Export class


module.exports = Attachment;